import { Link } from "react-router-dom";

export default function ErrorPage() {
  return (
    <div
      id="error-page"
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <h1 style={{ paddingBottom: 10 }}>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <Link
        to={{
          pathname: "/get-recommendations/coverage-year",
        }}
        className="button hollow"
        style={{ minWidth: "180px", minHeight: "60px", fontWeight: 500 }}
      >
        Go Back
      </Link>
    </div>
  );
}
